import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '& .pathway-list': {
        listStyle: 'none',
        paddingLeft: 0,
        [theme.breakpoints.up('md')]: {
          '& > li': {
            marginBottom: 32,
            paddingBottom: 32,
            borderBottom: `1px solid ${colorsPalette.violetAnalyticsCard}`,
            '&:last-child': {
              borderBottom: 'none',
              marginBottom: 0,
            },
          },
        },
      },
    },
    title: {
      fontSize: 14,
      lineHeigth: 1.5,
      color: 'rgba(255, 255, 255, 0.6)',
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    modal: {
      display: 'flex',
      justifyContent: 'center',
      alightItems: 'center',
    },
  }),
);

export default useStyles;
